import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from "@angular/router";

import {AuthenticationGuard} from "../shared/authentication";
import {PipesModule} from "../shared/pipes/pipes.module";
import {TranslateModule} from "@ngx-translate/core";
import {UiModule} from "../shared/ui/ui.module";
import {SdconnectModule} from "../shared/sdconnect/sdconnect.module";

import {SdconnectAdminComponent} from './sdconnect-admin.component';


const routes: Routes = [
  {
    path: 'admin',
    component: SdconnectAdminComponent,
    canActivate: [AuthenticationGuard]
  }
];


@NgModule({
  declarations: [
    SdconnectAdminComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule,
    UiModule,
    PipesModule,
    SdconnectModule
  ],
  exports:[
    SdconnectAdminComponent
  ]
})
export class SdconnectAdminModule { }
